import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Check, Shield, Download } from "lucide-react";
import CheckoutModal from "@/components/CheckoutModal";
import { sendPixelEvent } from "@/lib/pixelXApp";
import * as Sentry from '@sentry/react';

const Checkout = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleCheckout = async () => {
    Sentry.addBreadcrumb({
      category: 'ui',
      message: 'CTA button clicked',
      level: 'info',
      data: {
        component: 'Checkout',
        variant: window.location.pathname === '/b' ? 'B' : 'A',
      },
    });
    
    try {
      await sendPixelEvent('AddToCart');
      setModalOpen(true);
    } catch (error) {
      Sentry.captureException(error, {
        tags: { action: 'open_checkout_modal' },
      });
    }
  };

  const benefits = [
    "30 receitas completas e detalhadas",
    "Lista de compras consolidada",
    "Passo a passo simples e claro",
    "Substituições e variações",
    "Acesso imediato ao PDF",
    "Suporte por e-mail",
  ];

  return (
    <section id="checkout" className="py-16 lg:py-24 bg-gradient-hero">
      <div className="container">
        <div className="max-w-2xl mx-auto">
          <Card className="border-2 border-primary shadow-hover">
            <CardContent className="p-8 lg:p-12">
              <div className="text-center mb-8">
                <div className="inline-block rounded-full bg-primary/10 px-4 py-1.5 text-sm font-medium text-primary mb-4">
                  Oferta Especial
                </div>
                <h2 className="text-3xl font-bold mb-4">
                  Transforme seus almoços hoje
                </h2>
                <p className="text-muted-foreground mb-6">
                  Por apenas <span className="text-foreground font-bold">R$ 29,90</span>, você resolve o almoço do mês inteiro com variedade, rapidez e sabor.
                </p>
              </div>

              <div className="space-y-3 mb-8">
                {benefits.map((benefit, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="shrink-0 h-6 w-6 rounded-full bg-gradient-warm flex items-center justify-center">
                      <Check className="h-4 w-4 text-white" />
                    </div>
                    <span className="text-sm">{benefit}</span>
                  </div>
                ))}
              </div>

              <Button 
                onClick={handleCheckout}
                size="lg"
                className="w-full bg-gradient-warm hover:shadow-hover transition-all duration-300 text-xl h-16 mb-6"
              >
                Comprar agora — R$ 29,90
              </Button>

              <div className="flex items-center justify-center gap-6 text-sm text-muted-foreground">
                <div className="flex items-center gap-2">
                  <Shield className="h-4 w-4 text-primary" />
                  <span>Pagamento seguro</span>
                </div>
                <div className="flex items-center gap-2">
                  <Download className="h-4 w-4 text-primary" />
                  <span>Acesso imediato</span>
                </div>
              </div>
            </CardContent>
          </Card>

          <p className="text-center text-sm text-muted-foreground mt-6">
            Dúvidas? Entre em contato: <a href="mailto:contato@30receitasexpress.com" className="text-primary hover:underline">contato@30receitasexpress.com</a>
          </p>
        </div>
      </div>
      
      <CheckoutModal open={modalOpen} onOpenChange={setModalOpen} />
    </section>
  );
};

export default Checkout;
